import React from 'react';
import Modal from './Modal';

const SOUND_OPTIONS = [
  { key: 'bgm',      label: '🎵 Background Music' },
  { key: 'sfx',      label: '💥 Sound Effects'    },
  { key: 'collect',  label: '🏆 Collect Sounds'   },
  { key: 'gameover', label: '💀 Game Over Sound'  },
];

export default function SoundModal({ onClose, sounds, setSounds }) {
  return (
    <Modal title="🔊 Sound Settings" onClose={onClose}>
      {SOUND_OPTIONS.map(({ key, label }) => (
        <div className="toggle-wrap" key={key}>
          <span className="toggle-label">{label}</span>
          <div
            className={`toggle ${sounds[key] ? 'on' : ''}`}
            onClick={() => setSounds(s => ({ ...s, [key]: !s[key] }))}
          >
            <div className="toggle-thumb" />
          </div>
        </div>
      ))}
    </Modal>
  );
}